import Vue from 'vue'

/** 按 groupId 记录当前选中的 tabId（不写 URL） */
const state = Vue.observable({
  /** { [scopeId]: { [groupId]: tabId } } */
  activeTabByScopeGroup: {},
})

function normalizeScopeId (scopeId) {
  const s = scopeId == null || scopeId === '' ? 'global' : String(scopeId)
  return s || 'global'
}

function ensureScopeBucket (scopeId) {
  const sid = normalizeScopeId(scopeId)
  if (!state.activeTabByScopeGroup[sid]) {
    Vue.set(state.activeTabByScopeGroup, sid, {})
  }
  return state.activeTabByScopeGroup[sid]
}

export function getActiveTabId (groupId, scopeId) {
  const sid = normalizeScopeId(scopeId)
  const bucket = state.activeTabByScopeGroup[sid] || {}
  return bucket[groupId] || null
}

export function setActiveTabId (groupId, tabId, scopeId) {
  if (!groupId) return
  const bucket = ensureScopeBucket(scopeId)
  Vue.set(bucket, groupId, tabId)
}

export function initActiveTabIfEmpty (groupId, firstTabId, scopeId) {
  if (!groupId || !firstTabId) return
  const bucket = ensureScopeBucket(scopeId)
  if (bucket[groupId] == null || bucket[groupId] === '') {
    Vue.set(bucket, groupId, firstTabId)
  }
}

export function clearGroup (groupId, scopeId) {
  const sid = normalizeScopeId(scopeId)
  const bucket = state.activeTabByScopeGroup[sid]
  if (groupId && bucket && bucket[groupId] !== undefined) {
    Vue.delete(bucket, groupId)
  }
}
